<template>
  <v-layout row
            wrap>
    <v-flex class="xs12 sm6"
            v-for="parking in parkings"
            :key="parking.id">

      <v-card class="ma-2"
              height="95%"
              hover
              @click="goToReservationWithParking(parking)">

        <v-img min-height="200"
               :aspect-ratio="16/9"
               :src="parking.img">
          <div class="addressSmallScreen font-weight-medium"
               v-html="parking.address">
          </div>
        </v-img>
        <v-card-title class="font-weight-medium">
          <v-flex class="text-xs-left">{{parking.name}}</v-flex>
          <v-flex xs3>{{parking.distance | formatDistance}}</v-flex>
        </v-card-title>
        <v-card-actions v-if="showMaxAvailability(parking)"
                        class="pl-2">
          <v-layout row
                    wrap
                    class="text-xs-left pl-2">
            <v-flex class="grey--text text--darken-1 caption"
                    xs12>{{ $t('global.max.availability') }}</v-flex>
            <v-flex>{{parking.maxAvailability | formatDateMaxAvailabilityPark}}</v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AlternativeParkings',
  props: ['parkings', 'date'],
  methods: {
    goToReservationWithParking(parking) {
      let urlParkingDetail = this.$i18n.t('urlParkingDetail', { alias: parking.alias });
      this.$router.replace({ path: urlParkingDetail }, () => {
        this.$router.go();
      });
    },
    showMaxAvailability(parking) {
      return moment(this.date).utc().add(1, 'day').isAfter(parking.maxAvailability)
    }
  }
};
</script>

<style lang="scss" scoped>
.addressSmallScreen {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: #88c1dfd1;
  color: white;
  font-size: 1.2em;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 10px;
}
</style>
